module.exports = __webpack_public_path__ + "static/result_sillim-73e61f54324087b2ae8944554d6e9f53.png";